<template>
  <div>

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <v-alert v-if="alert" :value="true" type="success" >
      {{SnackbarVal.message}}
    </v-alert>

  <!--   {{formSchema}}
    <br><br>
    {{voucherData}} -->
    <!--___________ Search Form _____________ -->
    <v-card>
      <v-card-title >       
         <span class="headline">Re-Payment Installment Collection for Loan No.  {{voucherData.loan_no}}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation >
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>

             <v-flex xs12 sm6 md6>
                <v-text-field
                label="Payment Type"
                v-model="formSchema.payment_type"
                :rules="[v => !!v || 'Payment Type is required !']"
                required
                readonly
              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Re-Paymant Date"
                v-model="formSchema.re_paymant_date"
                :rules="[v => !!v || 'Re-Paymant date is required !']"
                required
                readonly
              ></v-text-field>
              </v-flex>

             <v-flex xs12 sm6 md6>
                <v-text-field
                label="Currency"
                v-model="formSchema.currency"
                :rules="[v => !!v || 'Currency is required !',spaces]"
                required
                readonly
              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="USD Rate"
                v-model="formSchema.usd_rate"
                :rules="[v => !!v || 'USD rate is required !', spaces, decimal]"
                required
                @input="getCurrencyRate"
                type="number"
              ></v-text-field>
              </v-flex>              

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Cheque No"
                v-model="formSchema.cheque_no"
                :rules="[v => !!v || 'Cheque no is required !']"
                required
              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
              <v-text-field
              label="Overdue Interest Rate"
              v-model="formSchema.overdue_interest_rate"
              :rules="[v => !!v || 'Overdue interest rate is required !']"
              required
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'cheque_date', fieldValue:formSchema.cheque_date, label:'Cheque Date', required:'1'}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'receive_date', fieldValue:formSchema.receive_date, label:'Receive Date', required:'1'}"
                @setValue="setDateValue"                
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Overdue Days"
              v-model="formSchema.overdue_days"
              type="number"      
              @input="getInterestAmount(formSchema.overdue_days)"     
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>      
              <v-text-field
              label="Overdue Amount"
              v-model="formSchema.overdue_amount"
              @input="getCurrencyRate"
              readonly
              type="number"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Installment amount"
              v-model="formSchema.installment_amount"
              :rules="[v => !!v || 'Installment amount is required !']"
              required
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Penalty Charge"
              v-model="formSchema.penalty_charge"
              type="number"
              @input="getInterestAmount"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Receive Amount"
              v-model="formSchema.receive_amount"
              :rules="[v => !!v || 'Receive amount is required !', decimal]"
              required 
              @input="changeAmount(formSchema.receive_amount)" 
              ></v-text-field>
            </v-flex>           
            
            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Comments"
              v-model="formSchema.comments"
              ></v-text-field>
            </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" v-if="saveBtn" @click.native="validateBeforeSubmit" :disabled="!valid">
                <v-icon>save</v-icon>
                Save
              </v-btn>
            </v-card-actions>

          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/ Search Form _____________ -->
    <br>
    <template>
      <v-card>
        <table class="paySchedule">
          <tbody>        
            <tr class="tb-td">
              <td>Economic Code</td>
              <td style="padding:0px;">Account Name</td>
              <td>TR Debit</td>
              <td>TR Credit</td>
              <td>Currency</td>
              <td>BDT Debit</td>
              <td>BDT Credit</td>
               <td>USD Debit</td>
               <td>USD Credit</td>
              <td>Src Fund</td>             
              <td>Loan no</td>
            </tr>
            <!-- __________________ Debit Row _________________ -->
            <tr>
              <td class="textCenter">
                <input type="text" v-model="debit.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.account_name" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="debit.tr_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="debit.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="debit.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.src_fund" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /Debit Row _________________ -->


            <!-- __________________ PRINCIPAL Row_________________ -->
            <tr>
              <td class="textCenter">
                <input type="text" v-model="principal.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.account_name" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="principal.tr_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="principal.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="principal.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.src_fund" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="principal.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /PRINCIPAL Row _________________ -->

            <!-- __________________ INTEREST Row_________________ -->
            <tr>
              <td class="textCenter">
                <input type="text" v-model="interest.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.account_name" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="interest.tr_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="interest.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="interest.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.src_fund" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="interest.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /INTEREST Row _________________ -->

            <!-- __________________ Overdue Amount Row_________________ -->
            <tr v-if="formSchema.overdue_amount>0">
              <td class="textCenter">
                <input type="text" v-model="overdue.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.account_name" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="overdue.tr_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="overdue.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="overdue.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.src_fund" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdue.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /Overdue Amount Row _________________ -->

            <!-- __________________ Penalty Charge Row_________________ -->
            <tr v-if="formSchema.penalty_charge>0">
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.account_name" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.tr_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.src_fund" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="overdueCharge.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /Penalty Charge Row _________________ -->
            
          </tbody>
        </table>
      </v-card>
    </template>
    
  </div>
</template>

<script>



let commonService = require("../../../services/common.service");
let UtilService = require("../../../services/util.service");
import DatePicker from "../../global/date_picker";

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      valid:true,
      e1: 0,
      saveBtn:true,
      alert:false,

      formSchema: {
        id:'',
        loan_id:"",
        payment_type:"Re-Payment",
        re_paymant_date:"",
        currency:"",
        usd_rate:"",
        comments:"",
        cheque_no:"",
        installment_amount:"",
        receive_amount:"",
        receive_date:"",
        cheque_date:"",
        loan_details_id:"",
        re_schedule_no:"",
        re_set_no:"",
        installment_no:"",
      },

      debit:
        {          
          eco_code:'',
          account_name:'',
          tr_debit:'',
          tr_credit:'',
          currency:'',
          bdt_debit:'',
          bdt_credit:'',
          usd_debit:'',
          usd_credit:'',
          src_fund:'',
          loan_no:'',
          amount_type:"Ins",
        },
      
      principal:
        {
          eco_code:'',
          account_name:'',
          tr_debit:'',
          tr_credit:'',
          currency:'',
          bdt_debit:'',
          bdt_credit:'',
          usd_debit:'',
          usd_credit:'',
          src_fund:'',
          loan_no:'',
          amount_type:"P",
        },

      interest:
        {
         eco_code:'',
         account_name:'',
         tr_debit:'',
         tr_credit:'',
         currency:'',
         bdt_debit:'',
         bdt_credit:'',
         usd_debit:'',
         usd_credit:'',
         src_fund:'',
         loan_no:'',
         amount_type:"I",
        },

        overdue:
        {
         eco_code:'',
         account_name:'',
         tr_debit:'',
         tr_credit:'',
         currency:'',
         bdt_debit:'',
         bdt_credit:'',
         usd_debit:'',
         usd_credit:'',
         src_fund:'',
         loan_no:'',
         amount_type:"Od",
        },

        overdueCharge:
        {
         eco_code:'',
         account_name:'',
         tr_debit:'',
         tr_credit:'',
         currency:'',
         bdt_debit:'',
         bdt_credit:'',
         usd_debit:'',
         usd_credit:'',
         src_fund:'',
         loan_no:'',
         amount_type:"C",
        },

      voucherData:'',

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    };
  },
  created() {
    let voucher = this.$store.getters.GET_RE_PAYMENT_DATA;
    this.voucherData = voucher

    if(!voucher.id)
    {
      this.$router.push('/on-lending/inst-collection');
    }
/*receive_amount*/
    
    let formSchema = this.formSchema

    formSchema.currency = voucher.currency;
    formSchema.loan_id = voucher.loan_id;
    formSchema.loan_details_id = voucher.id;
    formSchema.installment_amount = this.numberFormate(voucher.installment_amount);
    formSchema.re_schedule_no = voucher.re_schedule_no;
    formSchema.re_set_no = voucher.re_set_no;
    //formSchema.receive_amount = this.numberFormate(voucher.installment_amount);
    formSchema.installment_no = voucher.installment_no;
    formSchema.re_paymant_date = this.changeFormateDMY(voucher.installment_date);
    formSchema.overdue_interest_rate = voucher.overdue_interest_rate;
    formSchema.loan_no = voucher.loan_no;

    commonService.getAllDataById(voucher.loan_id,"get-collection-info").then(res => {        
      //console.log('res == ', res);
      
      let debit = this.debit;
      let principal = this.principal;
      let interest = this.interest;
      let overdue = this.overdue;
      let overdueCharge = this.overdueCharge

      let debitInterest = res.debitInfo.currency_rate; // come from lendin_loan_disbursements tbl
      let creditInterest = res.loanInfo.currency_rate; // come from lending_loan_profiles tbl
      
      
      debit.usd_debit = 0
      debit.usd_credit = 0

      principal.usd_debit = 0
      principal.usd_credit = 0

      interest.usd_debit = 0
      interest.usd_credit = 0


      debit.eco_code = res.debitInfo.debit_eco_code
      debit.account_name = res.debitInfo.debit_account_name
      debit.tr_debit = this.numberFormate(voucher.installment_amount)
      debit.tr_credit = 0;
      debit.currency = voucher.currency
      debit.bdt_debit = this.numberFormate(voucher.installment_amount)+''
      debit.bdt_credit = 0;
      debit.src_fund = res.debitInfo.fund_source
      debit.loan_no = voucher.loan_no

      /*_________________For principal______________*/
      principal.eco_code = res.creditInfo.credit_eco_code
      principal.account_name = res.creditInfo.credit_account_name
      principal.tr_debit = 0
      principal.tr_credit = this.numberFormate(voucher.principal)
      principal.currency = voucher.currency
      principal.bdt_debit = 0
      principal.bdt_credit = this.numberFormate(voucher.principal);
      principal.src_fund = res.debitInfo.fund_source
      principal.loan_no = voucher.loan_no
      /*_________________/For principal_____________*/

      /*_________________For principal______________*/
      interest.eco_code = res.creditInfo.credit_eco_code
      interest.account_name = res.creditInfo.credit_account_name
      interest.tr_debit = 0
      interest.tr_credit = this.numberFormate(voucher.interest)
      interest.currency = voucher.currency
      interest.bdt_debit = 0
      interest.bdt_credit = this.numberFormate(voucher.interest);
      interest.src_fund = res.debitInfo.fund_source
      interest.loan_no = voucher.loan_no
      /*_________________/For principal_____________*/

      /*_________________For Overdue ______________*/
      overdue.eco_code = res.creditInfo.credit_eco_code
      overdue.account_name = res.creditInfo.credit_account_name
      overdue.tr_debit = 0
      overdue.tr_credit = 0
      overdue.currency = voucher.currency
      overdue.bdt_debit = 0
      overdue.bdt_credit = 0
      overdue.src_fund = res.debitInfo.fund_source
      overdue.loan_no = voucher.loan_no
      /*_________________/For Overdue _____________*/

      /*_________________For Overdue Charge ______________*/
      overdueCharge.eco_code = res.creditInfo.credit_eco_code
      overdueCharge.account_name = res.creditInfo.credit_account_name
      overdueCharge.tr_debit = 0
      overdueCharge.tr_credit = 0
      overdueCharge.currency = voucher.currency
      overdueCharge.bdt_debit = 0
      overdueCharge.bdt_credit = 0  
      overdueCharge.src_fund = res.debitInfo.fund_source
      overdueCharge.loan_no = voucher.loan_no 
      /*_________________/For Overdue Charge _____________*/

    });


    commonService.getAllData("get-dis-dropdown-data").then(res => {        
      this.loanNoList = res.loanNoList;
    });
  },

  methods:{

    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;

      formSchema.re_paymant_date = this.changeFormateYMD(
        formSchema.re_paymant_date
      );
      formSchema.receive_date = this.changeFormateYMD(
        formSchema.receive_date
      );
      formSchema.cheque_date = this.changeFormateYMD(
        formSchema.cheque_date
      );

      formSchema.receive_amount = parseFloat(formSchema.receive_amount).toFixed(2);


      let instAmount = parseFloat(formSchema.installment_amount) + 
                      parseFloat(formSchema.overdue_amount) + 
                      parseFloat(formSchema.penalty_charge);

      console.log('instAmount = ', instAmount);
      if(instAmount != formSchema.receive_amount)
      {
       this.SnackbarVal.color = 'error';        
       this.SnackbarVal.message = 'Receive amount must be equal of installment amount';
       this.SnackbarVal.snackbar = true;
       return 0;
      }  

      let store = [];
      store[0] = this.debit;
      store[1] = this.principal;
      store[2] = this.interest;      
      
      if(formSchema.overdue_amount > 0){
        store[3] = this.overdue;
      }
      if(formSchema.penalty_charge > 0){
        store[4] = this.overdueCharge;
      }

      let formData = new FormData();

      formData.append("formSchema", JSON.stringify(formSchema));
      formData.append("store", JSON.stringify(store));

      /*formData.append("debit", JSON.stringify(this.debit));
      formData.append("principal", JSON.stringify(this.principal));
      formData.append("interest", JSON.stringify(this.interest));*/

      //formData.append("InstalmentData", JSON.stringify(this.InstalmentSaveData));

      commonService.insertFormData(formData, "re-payment").then(res => {

        if (res.status == 1) {     
          this.alert = true;
          this.saveBtn = false;
          this.Loader = false;

          window.scrollTo({
            top: 0,
            left: 100,
            behavior: "smooth"
          });

          setTimeout(function(){
            root.$store.commit('UNSET_RE_PAYMENT_DATA');
            root.$router.push("/on-lending/inst-collection");
          },6000);

        }
        if (res.status == 0) {
          this.SnackbarVal.color = 'error';
          formSchema.re_paymant_date = this.changeFormateDMY(formSchema.re_paymant_date);
        }
        else
        {
          this.SnackbarVal.color = 'success';
        }

        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
      });
    },

    getCurrencyRate()
    {
      let formSchema = this.formSchema;
      let voucher = this.voucherData;
      let debit = this.debit;
      let principal = this.principal;
      let interest = this.interest;

      let overdue = this.overdue;
      let overdueCharge = this.overdueCharge;

      /*usd_rate
      currency*/
      let creditInterest = formSchema.usd_rate;

      if(formSchema.currency == 'BDT')
      {
        //debit.usd_debit = this.numberFormate(voucher.installment_amount/creditInterest)
        debit.usd_debit = this.dividedMethodG(voucher.installment_amount,creditInterest)
        debit.usd_credit = 0

        principal.usd_debit = 0
        //principal.usd_credit = this.numberFormate(voucher.principal/creditInterest)
        principal.usd_credit = this.dividedMethodG(voucher.principal,creditInterest)

        interest.usd_debit = 0
        interest.usd_credit = this.dividedMethodG(voucher.interest,creditInterest)

        overdue.usd_debit = 0
        overdue.usd_credit = this.dividedMethodG(formSchema.overdue_amount,creditInterest)

        overdueCharge.usd_debit = 0
        overdueCharge.usd_credit = this.dividedMethodG(formSchema.penalty_charge,creditInterest)        

      }
      if(formSchema.currency == 'USD')
      { 

        //debit.usd_debit = this.numberFormate(voucher.installment_amount * voucher.currency);
        debit.usd_debit = this.multiplyMethodG(voucher.installment_amount , voucher.currency);
        debit.usd_credit = 0    

        principal.usd_debit = 0;
        principal.usd_credit = this.multiplyMethodG(voucher.principal , voucher.currency); 

        interest.usd_debit = 0
        interest.usd_credit = this.multiplyMethodG(voucher.interest , voucher.currency); 

        overdue.usd_debit = 0
        //overdue.usd_credit = this.numberFormate(parseFloat(formSchema.overdue_amount) * creditInterest)
        overdue.usd_credit = this.multiplyMethodG(formSchema.overdue_amount , creditInterest)

        overdueCharge.usd_debit = 0
        //overdueCharge.usd_credit = this.numberFormate(parseFloat(formSchema.penalty_charge) * creditInterest)
        overdueCharge.usd_credit = this.multiplyMethodG(formSchema.penalty_charge , creditInterest)

      }

      overdue.tr_credit = (formSchema.overdue_amount>0)?formSchema.overdue_amount:0;
      overdue.bdt_credit = (formSchema.overdue_amount>0)?formSchema.overdue_amount:0;   

      overdueCharge.tr_credit = (formSchema.penalty_charge>0)?formSchema.penalty_charge:0
      overdueCharge.bdt_credit = (formSchema.penalty_charge>0)?formSchema.penalty_charge:0    
    },

    numberFormate(numBer)
    {
      if(numBer != '-')
      {
        //return Number(numBer).toFixed(4);
        return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      }
      else
      {
       return '0.00'; 
      }
    },    

    getScheduleData()
    {
      let formSchema = this.formSchema

      //console.log('formSchema', formSchema);

      if(formSchema.from_date !="" )
      {
        formSchema.from_date = this.changeFormateYMD(
          formSchema.from_date
          );
      }
      if(formSchema.to_date !="" )
      {
        formSchema.to_date = this.changeFormateYMD(
          formSchema.to_date
          );
      }

      if (this.$refs.form.validate()) {  

        if(formSchema.loan_id != '')
        {
          commonService.dataByMulParameters(formSchema, "get-loan-schedule-data").then(res => {
            this.InstalmentData = res;
          });
        }
        else
        {
          this.SnackbarVal.color = 'error';
          this.SnackbarVal.message = 'Loan number is empty!';
          this.SnackbarVal.snackbar = true;
        }
      }
    },

    changeAmount(reveiceAmount){
      let formSchema = this.formSchema
      //console.log('formSchema.installment_amount', formSchema.installment_amount);
      let installment_amount = parseFloat(formSchema.installment_amount);
      let reveice_Amount = parseFloat(reveiceAmount);

      //console.log('installment_amount', installment_amount);

      if(installment_amount < reveice_Amount)
      {
        formSchema.receive_amount = 0

        this.SnackbarVal.message = 'Receive amount must be equal of installment amount';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error"
      }
      else
      {
        this.getCurrencyRate();
      }

    },

    getClientName(loan_id){
      console.log('loan_id', loan_id);

      let Loan = this.loanNoList.filter(function(a) {
        return a.id == loan_id;
      })[0].client_name;

      this.formSchema.client_name  = Loan;
    },


    getInterestAmount(getDays="")
    {

      let formSchema = this.formSchema      

      /*let re_paymant_date = this.changeFormateYMD(formSchema.re_paymant_date);
      let receiveDate = this.changeFormateYMD(formSchema.receive_date);

      let timeDiff  = (new Date(receiveDate)) - (new Date(re_paymant_date));
      let days      = timeDiff / (1000 * 60 * 60 * 24)
      let totalDays = (days < 0) ? 0 : days;*/

      let totalDays = formSchema.overdue_days;
      //formSchema.overdue_days = (getDays) ? getDays : totalDays;

      let interest_v =  ( parseFloat(formSchema.installment_amount) * (parseFloat(formSchema.overdue_interest_rate)/100) * totalDays /360);

      formSchema.overdue_amount = parseFloat(interest_v) > 0 ? Math.round(parseFloat(interest_v)) : 0;

      //console.log('overdue_amount == ',typeof(formSchema.overdue_amount));

      let penalty_charge = parseFloat(formSchema.penalty_charge > 0) ? formSchema.penalty_charge : 0;

      formSchema.receive_amount = Math.round(formSchema.installment_amount + interest_v + parseFloat(penalty_charge))

      if(formSchema.receive_amount>0)
      {
        this.getCurrencyRate();
      }

    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = (data.value != null) ? data.value : "";

      let formSchema = this.formSchema   
      let re_paymant_date = this.changeFormateYMD(formSchema.re_paymant_date);
      let receiveDate = this.changeFormateYMD(formSchema.receive_date);

      let timeDiff  = (new Date(receiveDate)) - (new Date(re_paymant_date));
      let days      = timeDiff / (1000 * 60 * 60 * 24)
      let totalDays = (days < 0) ? 0 : days;
      formSchema.overdue_days = totalDays;
      formSchema.penalty_charge = 0;

      this.getInterestAmount();
    },
    
  },

};
</script>

<style scoped>
table.paySchedule{
  width:100%;
  border-collapse: collapse;
}
.paySchedule td{
  border: 1px solid #CCC;
  line-height: 41px;
  text-align: center;
  text-align: center;
}
.paySchedule tr.tb-td td{
  font-weight: bold;
}
td.textCenter{
  text-align: center;
}
td.textRight{
  text-align: right;
}
td input{
  width:100%;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/installmentCollection/overDueInst.vue